var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page_services"}},[(_vm.doc != null)?_c('div',{staticClass:"content"},[_c('prismic-rich-text',{attrs:{"html-serializer":_vm.htmlSerializer,"field":_vm.doc.data.h1}}),_c('SliceZone',{attrs:{"slices":_vm.doc.data.body,"resolver":function (ref) {
	var sliceName = ref.sliceName;

	return _vm.slices[sliceName];
}}})],1):_vm._e(),_c('div',{staticClass:"skeleton"})])}
var staticRenderFns = []

export { render, staticRenderFns }